export class SeededRandom {
    private state: number;

    constructor(seed: number) {
        this.state = seed >>> 0;
    }

    next(): number {
        this.state = (1664525 * this.state + 1013904223) >>> 0;
        return this.state / 0x100000000;
    }

    integer(minInclusive: number, maxInclusive: number): number {
        return Math.floor(this.next() * (maxInclusive - minInclusive + 1)) + minInclusive;
    }

    float(minInclusive: number, maxExclusive: number, decimals = 4): number {
        const value = minInclusive + this.next() * (maxExclusive - minInclusive);
        const factor = 10 ** decimals;
        return Math.round(value * factor) / factor;
    }

    bool(probability = 0.5): boolean {
        return this.next() < probability;
    }

    pick<T>(items: readonly T[]): T {
        return items[this.integer(0, items.length - 1)]!;
    }
}

export const roundTo = (value: number, decimals: number): number => {
    const factor = 10 ** decimals;
    return Math.round(value * factor) / factor;
};

